module.exports = __webpack_public_path__ + "static/back3-2fee7f0118d58273b9382a2514bbedd0.png";